import React, { FC, useMemo, useEffect, useCallback } from "react"
import { useRequest } from "ahooks"
import { previewReport } from "@/api"
import LineDotted from "@components/ChartLineFlow/dotted"
import LabelRatioPie from "@components/LabelRatioPie"
import PieLegend from "@components/LabelRatioPie/withLegend"
import PieMore from "@components/LabelRatioPie/more"
import Map from "@components/Map"
import Bar from "@components/Bar/rank"
import StripRanking from "@components/Bar/strip"
import Loading from "@/components/Loading"
import Block from "@/components/BlockWrap"
import Selector from "@/components/Selector/index"
import { useSetState } from "@/reactUse"
import { getScatterSeries, getFlyLineSeries } from "@util/chart"
import { observer, inject } from "mobx-react"
import Env from "@util/env"

import "./index.scss"

const islandConf = {
  name: "张江AI智能岛",
  center: [121.609608, 31.185499],
}
const InitialCenter = [121.609608, 31.185599]

const Home: FC<any> = ({
  asComp,
  onChangeMapState,
  flyItem,
  flyActive,
  store,
}) => {
  const InitialZoom = 17 + Env.getScale()

  const { data, loading } = useRequest(previewReport, {})
  const [state, setState] = useSetState({
    series: [],
    zoom: InitialZoom,
    center: InitialCenter,
  })
  const flow = useMemo(() => {
    if (!data) {
      return null
    }
    let isWeekend = store.date.isoWeekday() >= 6
    const flow = {
      legend: [],
      data: [
        { name: "日均分时客流", data: [] },
        { name: isWeekend ? "周末分时客流" : "工作日分时客流", data: [] },
      ],
    }
    let perHourDay = isWeekend
      ? data.trafficsPerHourWeekday
      : data.trafficsPerHourWorkday
    for (let i = 3; i <= 23; i += 2) {
      flow.legend.push(i + "时")
      flow.data[0].data.push(data.trafficsPerHour[i])
      flow.data[1].data.push(perHourDay[i])
    }
    return flow
  }, [data, store.date])

  const {
    IndexPanelData,
    distributionIsNaiveProportion,
    distributionLiveProportion,
    distributionWork,
    distributionMarkert,
    distributionSexProportion,
    InsightAge,
  } = useMemo(() => {
    if (!data) {
      return {}
    }
    const _IndexPanelData = [
      { name: "到访客流人数", count: data.visitCount },
      { name: "工作日客流人数", count: data.workdayCount },
      { name: "周末客流人数", count: data.weekendCount },
    ]

    // 外来到访人口

    let distributionLiveProportion: any = data.distributionLiveProportion
    let total = 0 //1 - distributionLiveProportion[0].value
    distributionLiveProportion = distributionLiveProportion.slice(1, 20)
    distributionLiveProportion.forEach((city) => {
      total += city.value
    })
    distributionLiveProportion.forEach((city) => {
      city.value = Math.round((city.value * 100) / total) / 100
      // city.name = city.key
      city.fromName = city.name
      city.toName = islandConf.name
      city.coords = [city.center, islandConf.center]
      city.count = city.value * 1000
    })
    //

    // 年龄分布
    let _names = [
      "19岁以下",
      "19-25岁",
      "26-35岁",
      "36-45岁",
      "46-55岁",
      "55岁以上",
    ]
    const _InsightAge = data.distributionAgeProportion.map((v, i) => {
      return { name: _names[i], value: v }
    })
    return {
      IndexPanelData: _IndexPanelData,
      distributionLiveProportion,
      distributionWork: data.distributionWork.slice(0, 20).map((d) => {
        return {
          name: d.name,
          value: d.value,
          fromName: islandConf.name,
          toName: d.name,
          coords: [islandConf.center, d.center],
          center: d.center,
          count: d.value * 10000,
        }
      }),
      distributionSexProportion: [
        { name: "女性", value: data.distributionSexProportion[1] },
        { name: "男性", value: data.distributionSexProportion[0] },
      ],
      distributionIsNaiveProportion: [
        { name: "杭州市", value: data.distributionIsNaiveProportion[0] },
        { name: "北京市", value: data.distributionIsNaiveProportion[1] },
        { name: "苏州市", value: data.distributionIsNaiveProportion[2] },
        { name: "南京市", value: data.distributionIsNaiveProportion[3] },
        { name: "南通市", value: data.distributionIsNaiveProportion[4] },
      ],
      InsightAge: _InsightAge,
      distributionMarkert: data.distributionMarkert.slice(0, 20).map((d) => {
        return {
          name: d.name,
          value: d.value,
          fromName: islandConf.name,
          toName: d.name,
          coords: [islandConf.center, d.center],
          center: d.center,
          count: d.value * 10000,
        }
      }),
    }
  }, [data])
  const onClickFlyModel = useCallback(
    (item, active) => {
      let list = null
      let zoom = InitialZoom
      var icon = false
      let series = []
      let center = InitialCenter
      if (!active || !item) {
        // setState({
        series = [
          getScatterSeries("scatter_" + (item ? item.key : ""), []),
          ...getFlyLineSeries(
            "fly_" + (item ? item.key : ""),
            [],
            "red",
            false
          ),
        ]
        //   zoom: InitialZoom,
        //   center: InitialCenter,
        // })
      } else if (item.key === "work") {
        list = distributionWork
        zoom = 10.5
        icon = false
      } else if (item.key === "shopping") {
        list = distributionMarkert
        zoom = 12
        icon = false
      } else if (item.key === "from") {
        list = distributionLiveProportion
        icon = true
        zoom = 4
      }
      if (list) {
        center = [0, 0]
        list.forEach((item) => {
          center[0] += item.center[0]
          center[1] += item.center[1]
        })
        let len = list.length
        center = [center[0] / len, center[1] / len]
        series = [
          getScatterSeries("scatter_" + item.key, list, "#FF5555"),
          ...getFlyLineSeries("fly_" + item.key, list, item.color, icon),
        ]
        zoom = zoom + Env.getScale()
      }
      onChangeMapState
        ? onChangeMapState({ series, zoom, center })
        : setState({ series, zoom, center })
    },
    [
      distributionWork,
      distributionMarkert,
      distributionLiveProportion,
      onChangeMapState,
    ]
  )

  const tabs = useMemo(() => {
    return [
      { name: "常去办公楼", key: "work", color: "#00FFDB" },
      { name: "常去商圈", key: "shopping", color: "#00FFDB" },
      { name: "外来到访人口", key: "from", color: "#00FFDB" },
    ]
  }, [])
  useMemo(() => {
    onClickFlyModel(flyItem, flyActive)
  }, [flyItem, flyActive])
  useEffect(() => {
    onChangeMapState &&
      onChangeMapState({ series: [], zoom: InitialZoom, center: InitialCenter })
  }, [onChangeMapState])
  if (!data || loading) {
    return <Loading loading={loading} tip="正在获取报告数据" />
  }

  return (
    <div className="pg-insights flex flex-column">
      <div className="content flex-1">
        <div className="content-charts flex flex-column">
          <div className="content-row flex flex-1">
            <div className="con-left flex flex-column">
              <Block title="分时客流">
                <LineDotted data={flow} color={["#DED841", "#6D63FF"]} />
              </Block>
              <Block title="外来到访人口">
                <Bar data={distributionLiveProportion.slice(0, 5)} />
              </Block>
            </div>
            <div className="con-map flex flex-column">
              <Block>
                {!asComp && (
                  <Map
                    indoorVisible={false}
                    series={state.series}
                    zoom={state.zoom}
                    center={state.center}
                  />
                )}
              </Block>
              {!asComp && (
                <Selector icon tabs={tabs} onClick={onClickFlyModel} />
              )}
            </div>
            <div className="con-right flex flex-column">
              <Block title="常去办公楼">
                <StripRanking
                  data={distributionWork.slice(0, 5)}
                  highLightType="red"
                />
              </Block>
              <Block title="常去商圈">
                <StripRanking
                  data={distributionMarkert.slice(0, 5)}
                  highLightType="yellow"
                />
              </Block>
            </div>
          </div>
          <div className="content-row flex content-bottom">
            <div className={"block theme-default"}>
              <div className="block-inner">
                <div className="block-body flex ls-pie">
                  <div>
                    <div className="block-sbb-title">性别比例</div>
                    <div className="pie-con">
                      <PieMore data={distributionSexProportion} />
                      <div className="line"></div>
                    </div>
                  </div>
                  <div>
                    <div className="block-sbb-title">年龄分布</div>
                    <div className="pie-con">
                      <LabelRatioPie data={InsightAge} />
                      <div className="line"></div>
                    </div>
                  </div>
                  <div>
                    <div className="block-sbb-title">客源分析</div>
                    <div className="pie-con">
                      <PieLegend data={distributionIsNaiveProportion} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="block-inner block-idx">
                <div className="block-sbb-title">客户分布</div>
                <div className="block-body">
                  {IndexPanelData.map((item, i) => {
                    return (
                      <div className="it-idx" key={i}>
                        <div className="it-inner">
                          <span className="name">{item.name}</span>
                          <span className="count">
                            {item.count.toLocaleString()}
                          </span>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default inject("store")(observer(Home))
